import {useMemo} from 'react'
import {useCurrentBasket} from '@salesforce/retail-react-app/app/hooks/use-current-basket'
import {CART_FULL_ERROR_MESSAGE} from '../constants'

/**
 * Custom hook to check if cart has reached the 24 unique SKUs limit
 * SCAPI getProducts has a limit of 24 unique product IDs per request
 * @returns {Object} { isAtLimit, uniqueSkusCount, errorMessage }
 */
const useCartLimit = () => {
    const {data: basket} = useCurrentBasket()

    const cartLimitData = useMemo(() => {
        const SCAPI_SKU_LIMIT = 24

        // Count unique SKUs (product IDs) in the basket
        const uniqueProductIds = new Set()
        basket?.productItems?.forEach((item) => {
            uniqueProductIds.add(item.productId)
        })

        // Add gift certificates as they also count towards the limit
        const giftCertificateCount = basket?.giftCertificateItems?.length || 0
        const uniqueSkusCount = uniqueProductIds.size + giftCertificateCount

        // Check if at limit
        const isAtLimit = uniqueSkusCount >= SCAPI_SKU_LIMIT

        return {
            isAtLimit,
            uniqueSkusCount,
            maxLimit: SCAPI_SKU_LIMIT,
            errorMessage: isAtLimit ? CART_FULL_ERROR_MESSAGE : null
        }
    }, [basket?.productItems, basket?.giftCertificateItems])

    return cartLimitData
}

export default useCartLimit
